import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './exchange-availability.actions';
import { ExchangeAvailabilityState } from './exchange-availability.state';

/**
 * exchangeAvailability initial state
 */
export const exchangeAvailabilityInitialState: ExchangeAvailabilityState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for ExchangeAvailability Store
 */
export const exchangeAvailabilityReducerFeatures: ReducerTypes<ExchangeAvailabilityState, ActionCreator[]>[] = [
  on(actions.setExchangeAvailability, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateExchangeAvailability, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetExchangeAvailability, () => exchangeAvailabilityInitialState),

  on(actions.cancelExchangeAvailabilityRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failExchangeAvailability, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setExchangeAvailabilityFromApi, actions.updateExchangeAvailabilityFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * ExchangeAvailability Store reducer
 */
export const exchangeAvailabilityReducer = createReducer(
  exchangeAvailabilityInitialState,
  ...exchangeAvailabilityReducerFeatures
);
